import clsx from "clsx"
import { WeekPlanProps } from "../../config"

interface CardHeadlineProps {
	dayContent: WeekPlanProps
	className?: string
}
const CardHeadline: React.FC<CardHeadlineProps> = ({ dayContent, className }) => {
	return (
		<h2 className={clsx("h2 calenderCopyShadow ", className)}>{dayContent.cardHeadline}</h2>

		// <svg className={className || "absolute top-[5%] left-[5%] w-[95%]"} viewBox="0 0 332 130" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
		// 	{dayContent.cardHeadline.line1 && (
		// 		<text x="0%" y="22%" fontFamily="Amsi" fontSize={35} className="font-Amsi uppercase fill-white calenderCopyShadow">
		// 			{dayContent.cardHeadline.line1}
		// 		</text>
		// 	)}
		// 	{dayContent.cardHeadline.line2 && (
		// 		<text x="0%" y="52%" fontFamily="Amsi" fontSize={35} className="font-Amsi uppercase fill-white calenderCopyShadow">
		// 			{dayContent.cardHeadline.line2}
		// 		</text>
		// 	)}
		// 	{dayContent.cardHeadline.line3 && (
		// 		<text x="0%" y="82%" fontFamily="Amsi" fontSize={35} className="font-Amsi uppercase fill-white calenderCopyShadow">
		// 			{dayContent.cardHeadline.line3}
		// 		</text>
		// 	)}
		// </svg>
	)
}

export default CardHeadline
